import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.9 9.9c0-.3.1-.6.1-.9V5c0-2.8-4.3-5-10-5S0 2.2 0 5v4c0 .7.3 1.3.7 1.9s.9 1 1.5 1.3c0 .3-.1.6-.1.8v4c0 2.9 4.3 5 10 5s10-2.1 10-5v-4c0-.7-.3-1.3-.7-1.9s-.9-1-1.5-1.3ZM10 14c3.9 0 7.1-1 8.7-2.5.8.5 1.3 1 1.3 1.5 0 1.2-3.1 3-8 3s-7.9-1.7-8-2.9c1.9.7 4 1 6 .9m0-12c4.9 0 8 1.8 8 3s-3.1 3-8 3-8-1.8-8-3 3.1-3 8-3M2 8.1c2.4 1.4 5.2 2.1 8 1.9 2.8.1 5.6-.6 8-1.9V9c0 1.2-3.1 3-8 3s-8-1.8-8-3zM12 20c-4.9 0-8-1.8-8-3v-.9c2.4 1.4 5.2 2.1 8 1.9 2.8.1 5.6-.6 8-1.9v.9c0 1.2-3.1 3-8 3" }, null, -1)
  ])))
}
export default { render: render }